export type PortalCapability = "order" | "viewResults" | "downloadPdfs";

export interface PortalCapabilities {
  canOrder: boolean;
  canViewResults: boolean;
  canDownloadPdfs: boolean;
}

export function hasPortalCapability(
  capabilities: PortalCapabilities,
  capability: PortalCapability,
): boolean {
  switch (capability) {
    case "order":
      return capabilities.canOrder;
    case "viewResults":
      return capabilities.canViewResults;
    case "downloadPdfs":
      return capabilities.canDownloadPdfs;
  }
}
